import { render, staticRenderFns } from "./AllStudentsUniversity.vue?vue&type=template&id=045cdce0&scoped=true&"
import script from "./AllStudentsUniversity.vue?vue&type=script&lang=js&"
export * from "./AllStudentsUniversity.vue?vue&type=script&lang=js&"
import style0 from "./AllStudentsUniversity.vue?vue&type=style&index=0&id=045cdce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cdce0",
  null
  
)

export default component.exports